module.exports = __webpack_public_path__ + "img/vulcano_black_ba_list.68bfdf4d.jpg";